"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatMessagesProvider = void 0;
const domain_1 = require("@home-health-notify/domain");
const react_1 = __importStar(require("react"));
const ChatMessagesContext_1 = require("./ChatMessagesContext");
const useScrollLock_1 = require("../hooks/useScrollLock"); // Do not shorten this import as it creates a cyclic dependency
const ChatContext_1 = require("./ChatContext");
const ChatMessagesProvider = ({ children, }) => {
    const [isMessageLoading, setIsMessageLoading] = (0, react_1.useState)(false);
    const paginationAbortContext = (0, react_1.useRef)(undefined);
    const { concurrencySafe } = (0, useScrollLock_1.useScrollLock)();
    const { chat } = (0, react_1.useContext)(ChatContext_1.ChatContext);
    (0, react_1.useEffect)(() => {
        return () => {
            var _a;
            (_a = paginationAbortContext.current) === null || _a === void 0 ? void 0 : _a.abort();
        };
    }, []);
    const setMessagesWithLoader = (messageFetcher) => __awaiter(void 0, void 0, void 0, function* () {
        setIsMessageLoading(true);
        yield messageFetcher();
        setIsMessageLoading(false);
    });
    const scrollMessages = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!isMessageLoading) {
            if (!!chat && chat.messages.hasNext) {
                yield concurrencySafe(() => __awaiter(void 0, void 0, void 0, function* () {
                    yield setMessagesWithLoader(() => __awaiter(void 0, void 0, void 0, function* () {
                        var _a;
                        paginationAbortContext.current =
                            ((_a = paginationAbortContext.current) === null || _a === void 0 ? void 0 : _a.renew()) || new domain_1.AbortContext();
                        yield chat.fetchMessages(paginationAbortContext.current);
                    }));
                }));
            }
        }
    });
    return (react_1.default.createElement(ChatMessagesContext_1.ChatMessagesContext.Provider, { value: {
            scrollMessages,
            isMessageLoading,
        } }, children));
};
exports.ChatMessagesProvider = ChatMessagesProvider;
